//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as orderTagApi from '@/api/orderTagApi.js';
import { Debounce } from '@/utils/validate';
export default {
  data: function data() {
    return {
      loading: false,
      visible: false,
      details: {},
      // 预留一份数据
      orderNo: '',
      tagOption: [{
        value: 1,
        name: '标签一'
      }, {
        value: 2,
        name: '标签二'
      }],
      checkboxGroup: null,
      pram: {},
      initloading: false
    };
  },
  props: {
    bindType: {
      // 打标类型 0: 订单列表打标 1: 三方订单打标
      type: [Number, String],
      default: 0
    }
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(orderNo) {
      this.orderNo = orderNo;
      this.pram = {};
      this.getAllTags(orderNo);
    },
    handerSubmit: Debounce(function () {
      var _this = this;
      this.loading = true;
      var _this$pram = this.pram,
        tagId = _this$pram.tagId,
        tagRemark = _this$pram.tagRemark;
      orderTagApi[this.bindType == 1 ? 'addVirtualTag' : 'orderBindTag']({
        orderNo: this.orderNo,
        tagId: tagId,
        tagRemark: tagRemark
      }).then(function (data) {
        _this.$message.success('操作成功');
        _this.loading = false;
        _this.visible = false;
        _this.$emit('doRefresh');
      }).catch(function () {
        _this.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getAllTags: function getAllTags(orderNo) {
      var _this2 = this;
      this.visible = true;
      this.initloading = true;
      this.tagOption = [];
      orderTagApi[this.bindType == 1 ? 'bindThirdTagDetails' : 'bindTagDetails'](orderNo).then(function (res) {
        var _ref = res || {},
          _ref$tagList = _ref.tagList,
          tagList = _ref$tagList === void 0 ? [] : _ref$tagList,
          tagRemark = _ref.tagRemark;
        var idx = tagList.findIndex(function (tagItem) {
          return tagItem.isChecked;
        });
        _this2.pram = {
          tagId: idx != -1 ? tagList[idx].tagId : null,
          tagRemark: tagRemark
        };
        _this2.tagOption = tagList || [];
        _this2.initloading = false;
      }).catch(function (err) {
        _this2.initloading = false;
      });
    }
  }
};